//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {events} from '@nuskin/ns-util';
import {CartService} from '@nuskin/ns-shop';
import QualificationService from '@nuskin/exclusive-offer-sdk';
import {NsIcon} from '@nuskin/ns-icon';
import debounce from 'lodash/debounce';

/* eslint-disable no-invalid-this */

export default {
  name: 'ExclusiveOfferInformation',
  components: {
    NsIcon
  },
  props: {
    sku: {
      type: String,
      required: true
    },
    isExclusive: {
      type: Boolean,
      required: true
    },
    userIsQualified: {
      type: Boolean,
      required: true
    },
    maxQuantity: {
      type: Number,
      required: true
    },
    hideIcon: Boolean
  },
  data() {
    return {
      exclusiveOfferMessage: '',
      exclusiveOfferMessageType: ''
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.state.user.isLoggedIn;
    },
    exclusiveOfferTitle() {
      return this.$t('exclusiveOffer.title');
    },
    exclusiveType() {
      if (this.isExclusive && this.userIsQualified) {
        return 'Qualified';
      } else {
        return 'Not qualified';
      }
    },
    showExclusiveOfferMessage() {
      return !this.userIsQualified && !!this.exclusiveOfferMessage;
    },
    showSignIn() {
      return this.showExclusiveOfferMessage && !this.isLoggedIn;
    }
  },
  watch: {
    async sku() {
      await this.checkExclusiveOfferMessage();
    },
    async isExclusive() {
      await this.checkExclusiveOfferMessage();
    },
    async userIsQualified() {
      await this.checkExclusiveOfferMessage();
    },
    async maxQuantity() {
      await this.checkExclusiveOfferMessage();
    }
  },
  async mounted() {
    await this.setExclusiveOfferMessage();
  },
  methods: {
    async setExclusiveOfferMessage() {
      this.exclusiveOfferMessage = '';
      this.exclusiveOfferMessageType = '';
      this.showSignInButton = false;

      if (this.isExclusive) {
        if (this.isLoggedIn) {
          const productQualification = await QualificationService.getQualification(
            this.sku
          );
          const cartItem = await CartService.getFirstItemBySku(this.sku, {
            cartOrderItems: true
          });
          const cartQuantity = (cartItem || {}).qty || 0;

          if (!productQualification) {
            // the event has never been set up or is in the past (post-event/qualification not configured)
            this.exclusiveOfferMessage = this.$t(
              'exclusiveOffer.noQualification'
            );
            this.exclusiveOfferMessageType = 'noQualification';
          } else if (
            (this.userIsQualified && !this.maxQuantity) ||
            (!this.userIsQualified && !productQualification.quantity) ||
            productQualification.quantity === cartQuantity
          ) {
            // qualified to purchase but no quantity available anymore OR not qualified and no qualified quantity left (used qualified quantity)
            this.exclusiveOfferMessage = this.$t('exclusiveOffer.usedUpQty');
            this.exclusiveOfferMessageType = 'usedUpQty';
          } else if (
            !this.userIsQualified &&
            productQualification.quantity > 0
          ) {
            // not qualified to purchase and quantity is available from qualification (pre-event)
            this.exclusiveOfferMessage = this.$t('exclusiveOffer.notAvailable');
            this.exclusiveOfferMessageType = 'notAvailable';
          }
        } else {
          // not logged in to receive exclusive offer
          this.exclusiveOfferMessage = this.$t('exclusiveOffer.message');
          this.exclusiveOfferMessageType = 'exclusiveOfferMessage';
        }
      }
    },

    checkExclusiveOfferMessage: debounce(async function () {
      await this.setExclusiveOfferMessage();
    }, 350),

    handleSignIn() {
      events.publish(events.authentication.REQUEST_FOR_LOGIN, {
        href: window.location.href
      });
    }
  }
};
